import React, { useState, useEffect, useRef, MouseEvent as ReactMouseEvent } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Breadcrumb, Grid, Header, Button, Icon, Table, Modal } from 'semantic-ui-react';
import { EmployerPartnerData } from './useEmployerPartnerForm';
import { EditEmployerPartnerForm } from './EditEmployerPartnerForm';
import { getEmployerPartners } from '../../../Services/EmploymentOpportunityService';
import { utils } from '../../../helpers/utils';
import { EditEmployerOpportunitiesForm } from './EditEmployerOpportunitiesForm';


export function PublicEmploymentOpportunities() {
    const defaultPartnerData: EmployerPartnerData = {
        employerPartnerId: 0,
        name: '',
        website: ''
    };
    const [listData, setListData] = useState<EmployerPartnerData[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedPartnerData, setSelectedPartnerData] = useState<EmployerPartnerData | null>(null);

    useEffect(() => {
        _fetchData();
    }, []);

    function _fetchData() {
        getEmployerPartners().then((response) => {
            if (response && response.status === 200 && response.data) {
                setListData(response.data as EmployerPartnerData[]);
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    function _closeModal() {
        setSelectedPartnerData(null);
        _fetchData();
    }
    const hasData: boolean = listData.length > 0;
    const isModelOpen: boolean = selectedPartnerData === null ? false : true;
    const modalTitle: string = selectedPartnerData?.employerPartnerId === 0 ? 'Add A Partner' : 'Edit Partner';
    return (<>
        <Container style={{ position: 'relative' }}>
            <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem', display: 'inline-block' }}>Employment Opportunities</Header>
            <hr style={{ marginBottom: '1.0rem' }} />
            <Breadcrumb style={{ marginBottom: '1.0rem' }}>
                <Breadcrumb.Section link><Link to='/'>Home</Link></Breadcrumb.Section>
                <Breadcrumb.Divider />
                <Breadcrumb.Section active>Employment Opportunities</Breadcrumb.Section>
            </Breadcrumb>
            <Grid columns={2}>
                <Grid.Column width={16}>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <h2>RSA Employer Partners</h2>
                    </div>
                    <div className='vertical-scroll-15'>
                        <Table striped color='red'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Name</Table.HeaderCell>
                                    <Table.HeaderCell>Website<Icon style={{marginLeft:'0.5rem'}} name='external alternate' /></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {
                                    !hasData &&
                                    <Table.Row>
                                        <Table.Cell colSpan={2}>No Data Available</Table.Cell>
                                    </Table.Row>
                                }
                                {
                                    hasData && listData.map((item, index) => {
                                        return (<Table.Row key={index}>
                                            <Table.Cell><span title={item.name}>{utils.getFixedLengthText(item.name, 40)}</span></Table.Cell>
                                            <Table.Cell><a title={item.website} target={'_blank'} href={item.website}>{utils.getFixedLengthText(item.website, 60)}</a></Table.Cell>
                                        </Table.Row>);
                                    })
                                }
                            </Table.Body>
                        </Table>
                    </div>
                </Grid.Column>
                <Grid.Column>

                </Grid.Column>
            </Grid>
            <Grid columns={2}>
                <Grid.Column width={16}>
                   <EditEmployerOpportunitiesForm isAdmin={false}/>
                </Grid.Column>
                <Grid.Column>
                   
                </Grid.Column>
            </Grid>
        </Container>
    </>);
}